export default __webpack_public_path__ + "static/media/remove_vehicle.075103af.svg";